import Row from '@pretto/bricks/shared/components/Row'

import PropTypes from 'prop-types'
import { memo } from 'react'

import * as S from './styles'

export const Date = memo(({ inputDateProps, description, title, ...props }) => (
  <div {...props}>
    <Row label={<S.Title>{title}</S.Title>} value={<S.InputDate {...inputDateProps} />} />

    <S.Description>{description}</S.Description>
  </div>
))

Date.propTypes = {
  description: PropTypes.string.isRequired,
  inputDateProps: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}

Date.displayName = 'Date'
